export default function(str) {
  return str.split(' ')
  .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
  .join(' ')
}


// WEBPACK FOOTER //
// ./src/utils/properCase.js